import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import CheckIcon from "@mui/icons-material/Check";
import { clearForgetpassChange, forgetpassChange } from "../../redux/handlers/auth/forgetpassChange.handler";
export function ForgetpassChange() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState("password"), 2), inputtype = _useState[0], setInputtype = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), formdisabled = _useState1[0], setFormdisabled = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState2[0], setModalsuccess = _useState2[1];
    var forgetpassChangeReducer = useAppSelector(function(state) {
        return state.forgetpassChangeReducer;
    });
    var _useState3 = _sliced_to_array(useState(function() {
        var params = new URLSearchParams(window.location.search);
        return params.get("email") || "";
    }), 2), email = _useState3[0], setEmail = _useState3[1];
    var _useState4 = _sliced_to_array(useState(function() {
        var params = new URLSearchParams(window.location.search);
        return params.get("token") || "";
    }), 2), token = _useState4[0], setToken = _useState4[1];
    useEffect(function() {
        localStorage.clear();
    }, []);
    var schema = yup.object().shape({
        email: yup.string().email("กรุณากรอกอีเมลให้ถูกต้อง").required("กรุณากรอกอีเมล"),
        resetpass: yup.string().required("กรุณากรอกรหัสผ่าน").min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
        confirmresetpass: yup.string().required("กรุณากรอกยืนยันรหัสผ่าน").min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร").oneOf([
            yup.ref("resetpass"),
            null
        ], "รหัสผ่านไม่ตรงกัน")
    });
    var _useState5 = _sliced_to_array(useState({
        token: token,
        email: email,
        resetpass: "",
        confirmresetpass: ""
    }), 2), formData = _useState5[0], setFormData = _useState5[1];
    var handleForgetpassChange = function(values) {
        if (!values.email || values.email === "" || values.email === undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/forgetpass"),
                title: "กรุณาทำรายการลืมรหัสใหม่อีกครั้ง"
            }));
            return;
        }
        dispatch(forgetpassChange(values, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(forgetpassChangeReducer.isFetching);
        if (forgetpassChangeReducer.data && forgetpassChangeReducer.isError) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: undefined,
                title: forgetpassChangeReducer.data.message
            }));
            return;
        }
        if (forgetpassChangeReducer.data && !forgetpassChangeReducer.isError) {
            localStorage.setItem("forgetpassToken", formData.token);
            localStorage.setItem("forgetpassEmail", forgetpassChangeReducer.data.data.mb_mem_email);
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "บันทึกข้อมูลสำเร็จ",
                    direction: "/forgetpass/success"
                });
            });
            setFormdisabled(true);
            dispatch(clearForgetpassChange());
        }
    }, [
        forgetpassChangeReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "loginpage bg-white",
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: "g-0",
                children: /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        style: {
                            maxWidth: "600px"
                        },
                        children: /*#__PURE__*/ _jsx(Formik, {
                            initialValues: formData,
                            validationSchema: schema,
                            onSubmit: handleForgetpassChange,
                            children: function(param) {
                                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue;
                                return /*#__PURE__*/ _jsxs(Form, {
                                    noValidate: true,
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card card-st-2",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body p-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-20 fw-500 tc-1 mb-3",
                                                        children: "กำหนดรหัสผ่านใหม่"
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "อีเมล ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "email",
                                                                placeholder: "กรอกอีเมล",
                                                                value: values.email,
                                                                onChange: handleChange,
                                                                isValid: touched.email && !errors.email,
                                                                isInvalid: !!errors.email,
                                                                className: "form-st-1",
                                                                disabled: true
                                                            }),
                                                            errors.email && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.email
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "รหัสผ่าน ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "position-relat</Form.Label>ive",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: inputtype,
                                                                        name: "resetpass",
                                                                        placeholder: "กรอกรหัสผ่าน",
                                                                        onChange: handleChange,
                                                                        isValid: touched.resetpass && !errors.resetpass,
                                                                        isInvalid: !!errors.resetpass,
                                                                        className: "form-st-1"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Button, {
                                                                        type: "button",
                                                                        className: "btn btn-change-type-password",
                                                                        onClick: function() {
                                                                            return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.resetpass && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.resetpass
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "ยืนยันรหัสผ่าน ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "position-relative",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: inputtype,
                                                                        name: "confirmresetpass",
                                                                        placeholder: "กรอกยืนยันรหัสผ่าน",
                                                                        onChange: handleChange,
                                                                        isValid: touched.confirmresetpass && !errors.confirmresetpass,
                                                                        isInvalid: !!errors.confirmresetpass,
                                                                        className: "form-st-1 mb-3"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Button, {
                                                                        type: "button",
                                                                        className: "btn btn-change-type-password",
                                                                        onClick: function() {
                                                                            return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.confirmresetpass && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.confirmresetpass
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Col, {
                                            className: "d-flex justify-content-center align-items-center mt-4",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    onClick: function() {
                                                        return navigate("/login");
                                                    },
                                                    className: "btn-return w-40 mr-2",
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-login w-40",
                                                    disabled: forgetpassChangeReducer.isFetching,
                                                    children: "ยืนยัน"
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
